import { render, staticRenderFns } from "./UserManagementItem.vue?vue&type=template&id=15aab3f0"
import script from "./UserManagementItem.vue?vue&type=script&lang=ts"
export * from "./UserManagementItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports